var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg401({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "357px",
    height: "350px",
    viewBox: "0 0 357 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-13.5%",
    y: "-12.9%",
    width: "126.9%",
    height: "125.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.615111451 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Errors/unique/401",
    transform: "translate(-552.000000, -155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(552.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#F2F2F2",
    fontFamily: "GEInspira-Bold, GE Inspira",
    fontSize: 220,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    id: 4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 165
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 219,
    y: 165
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "You-do-not-have-perm",
    fontFamily: "GEInspira, GE Inspira",
    fontSize: 31,
    fontWeight: "normal",
    "line-spacing": 31,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 276
  }, "You do not have "), /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 307
  }, "permission to access that.")), /*#__PURE__*/React.createElement("text", {
    id: "Contact-your-adminis",
    fontFamily: "MuseoSans-300, Museo Sans",
    fontSize: 15,
    fontWeight: 300,
    "line-spacing": 20,
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 344
  }, "Contact your administrator for access."))), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    filter: "url(#filter-1)",
    transform: "translate(94.469801, 61.197864)",
    fill: "#47ADC1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7035868,142.731059 C112.721838,142.731059 142.731059,112.721838 142.731059,75.7035868 C142.731059,38.685336 112.721838,8.67611442 75.7035868,8.67611442 C38.685336,8.67611442 8.67611442,38.685336 8.67611442,75.7035868 C8.67611442,112.721838 38.685336,142.731059 75.7035868,142.731059 Z M75.7035868,121.564489 C50.3753099,121.564489 29.8426846,101.031864 29.8426846,75.7035868 C29.8426846,50.3753099 50.3753099,29.8426846 75.7035868,29.8426846 C101.031864,29.8426846 121.564489,50.3753099 121.564489,75.7035868 C121.564489,101.031864 101.031864,121.564489 75.7035868,121.564489 Z",
    id: "Oval",
    transform: "translate(75.703587, 75.703587) rotate(-8.000000) translate(-75.703587, -75.703587) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.806594,197.6065 C130.806594,198.731309 130.374638,199.810065 129.605718,200.605533 C126.042863,204.29109 126.042863,204.29109 122.883499,207.557968 C120.685739,209.830255 116.938126,208.847625 116.05253,205.766874 C113.235538,195.967325 103.732773,186.117418 94.3623131,182.958209 C91.4522357,181.97709 90.56903,178.164221 92.7333374,175.925793 C113.125572,154.835186 138.520411,128.542302 168.917748,97.0472482 C169.68712,96.2500936 170.731443,95.802136 171.82048,95.802136 L196.428811,95.802136 C198.693946,95.802136 200.530199,97.7012763 200.530199,100.043984 L200.530199,125.495075 C200.530199,126.620083 200.09809,127.699014 199.328931,128.494515 L195.227542,132.736364 C194.458383,133.531865 193.415178,133.978772 192.327422,133.978772 L180.023257,133.978772 L180.023257,146.704318 C180.023257,147.829326 179.591148,148.908257 178.821988,149.703758 L174.720599,153.945606 C173.95144,154.741107 172.908235,155.188015 171.82048,155.188015 L155.414926,155.188015 L155.414926,172.155409 C155.414926,173.280416 154.982816,174.359348 154.213657,175.154849 L150.112268,179.396697 C149.343109,180.192198 148.299904,180.639106 147.212149,180.639106 L130.806594,180.639106 L130.806594,197.6065 Z",
    id: "Path",
    transform: "translate(146.030199, 152.302136) scale(1, -1) translate(-146.030199, -152.302136) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg401);
export default __webpack_public_path__ + "static/media/401.8b9a35ec081300f76bf230209c8fbbf9.svg";
export { ForwardRef as ReactComponent };